<template>
    <div class="box card-box">
        <p class="small-box-title">
            {{ title }}
        </p>
        <transition
            name="fade"
            mode="out-in"
        >
            <div v-if="false === userCard">
                <p class="no-payment-method-message">
                    No payment method available for this subscription.
                    <a
                        href="#"
                        @click.prevent="handleUpdate"
                    >
                        Add payment method
                    </a>
                </p>
            </div>
            <div
                v-else-if="!userCard"
                class="loader"
            >
                <i class="fas fa-spinner fa-spin loader" />
            </div>
            <div
                v-else
                class="card-info"
            >
                <span class="card-number">
                    <i :class="userCard.brandClass" />
                    **** ***** **** {{ userCard.last4 }}
                </span>
                <span class="card-expiry">Exp.  {{ userCard.expiryDate }}</span>
                <a
                    class="link"
                    href="#"
                    @click.prevent="handleUpdate"
                >
                    {{ updateText }}
                </a>
            </div>
        </transition>

        <transition
            name="fade"
            mode="out-in"
        >
            <!-- TODO: Enable when proper upcomingInvoice will be generated.
            This needs to include currently selected plan. -->
            <!-- <div
                v-if="upcomingInvoice"
                class="next-invoice"
            >
                Your next bill for <span class="detail">{{ usdFormatter( upcomingInvoice.amount_due ) }}
                </span> is coming on <span class="detail">{{ date( upcomingInvoice.next_payment_attempt ) }}</span>
            </div> -->
        </transition>
    </div>
</template>

<script>
import moment from 'moment';
import {
    mapState,
    mapGetters,
    mapMutations,
} from 'vuex';
import usdFormatter from '@/utils/usdFormatter';

export default {
    props: {
        upgradeOption: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: 'Credit Card',
        },
        updateText: {
            type: String,
            default: 'Update Credit Card',
        },
    },

    computed: {
        ...mapState({
            upcomingInvoice: state =>
                state.currentSubscription?.name ? state.upcomingInvoice : null,
        }),

        ...mapGetters(['userCard']),
    },

    methods: {
        ...mapMutations(['changeUIState']),

        usdFormatter,

        /**
         * Formats date
         *
         * @param   { number }  date  Date timestamp
         * @returns  { string }  Formated date.
         */
        date(date) {
            const momentDate = moment.unix(date);

            return momentDate.isSame(new Date(), 'day') || null === date
                ? 'today' : momentDate.format('MMM D, YYYY');
        },

        /**
         * Handles open update click
         */
        handleUpdate() {
            if (this.upgradeOption) {
                this.$emit('switch-to-upgrade');
            } else {
                this.changeUIState({ isUpdateModalVisible: true });
            }
        },
    },
};
</script>
